var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c("p", [
            _vm._v("\n      " + _vm._s(_vm.$t("admin.jira_desc")) + "\n    "),
          ]),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "jira-url",
              label: _vm.$t("admin.jira_url"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "text",
              lazy: "true",
            },
            model: {
              value: _vm.jiraUrl,
              callback: function ($$v) {
                _vm.jiraUrl = $$v
              },
              expression: "jiraUrl",
            },
          }),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: {
                  id: "jiraAuthWithTokenEnabled",
                  color: "primary",
                  label: "",
                },
                model: {
                  value: _vm.enabled,
                  callback: function ($$v) {
                    _vm.enabled = $$v
                  },
                  expression: "enabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(_vm._s(_vm.$t("admin.bearer_token_auth_enable")) + "\n    "),
          !_vm.enabled
            ? _c("b-validated-input-group-form-input", {
                attrs: {
                  id: "jira-username",
                  label: _vm.$t("admin.jira_username"),
                  "input-group-size": "mb-3",
                  rules: "required",
                  type: "text",
                  lazy: "true",
                },
                model: {
                  value: _vm.jiraUsername,
                  callback: function ($$v) {
                    _vm.jiraUsername = $$v
                  },
                  expression: "jiraUsername",
                },
              })
            : _vm._e(),
          !_vm.enabled
            ? _c("b-validated-input-group-form-input", {
                attrs: {
                  id: "jira-password",
                  label: _vm.$t("admin.jira_password"),
                  "input-group-size": "mb-3",
                  type: "password",
                  lazy: "true",
                  conceal: "true",
                },
                model: {
                  value: _vm.jiraPassword,
                  callback: function ($$v) {
                    _vm.jiraPassword = $$v
                  },
                  expression: "jiraPassword",
                },
              })
            : _vm._e(),
          _vm.enabled
            ? _c("b-validated-input-group-form-input", {
                attrs: {
                  id: "jira-token",
                  label: _vm.$t("admin.jira_auth_with_token"),
                  "input-group-size": "mb-3",
                  type: "password",
                  lazy: "true",
                  conceal: "true",
                },
                model: {
                  value: _vm.jiraPassword,
                  callback: function ($$v) {
                    _vm.jiraPassword = $$v
                  },
                  expression: "jiraPassword",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: { variant: "outline-primary" },
              on: { click: _vm.saveChanges },
            },
            [_vm._v(_vm._s(_vm.$t("message.update")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }